
























import { Vue, Component, Prop } from "vue-property-decorator";

interface Option {
  label: string;
  value: string | number;
}

@Component
export default class KSelectOption extends Vue {
  @Prop() value!: string;
  @Prop() label!: string;
  @Prop() options!: (Option | string)[];
}
